import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { PiCaretLeft } from 'react-icons/pi'
import { saveKpi } from './kpis'
import { REPORTING_PAGE_SHELL } from './page-shell'

export default function NewGoalPage() {
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [value, setValue] = useState<number | ''>('')
  const [dir, setDir] = useState<'above' | 'below'>('above')

  const canSave = name.trim() !== '' && value !== ''

  const handleSave = () => {
    if (!canSave) return
    saveKpi({ name: name.trim(), value: Number(value), dir })
    navigate('/reporting')
  }

  return (
    <div className={REPORTING_PAGE_SHELL}>
      <div>
        <Link
          to="/reporting/new"
          className="inline-flex items-center gap-1 text-sm text-fg-secondary hover:text-fg"
        >
          <PiCaretLeft size={14} /> Back
        </Link>
        <h1 className="mt-2 text-2xl font-bold text-fg">New goal</h1>
        <p className="mt-1 text-sm text-fg-secondary">
          A reusable target you can link to reports and charts.
        </p>
      </div>

      <div className="w-full max-w-md rounded-2xl border border-line bg-surface p-6">
        <div className="flex flex-col gap-4">
          <label htmlFor="goal-name" className="flex flex-col gap-1.5">
            <span className="text-sm font-medium text-fg">Name</span>
            <input
              id="goal-name"
              aria-label="Goal name"
              type="text"
              placeholder="e.g. Quarterly revenue target"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="h-9 rounded-lg border border-line bg-surface px-3 text-sm text-fg outline-none focus:border-line-focus"
            />
          </label>

          <label htmlFor="goal-value" className="flex flex-col gap-1.5">
            <span className="text-sm font-medium text-fg">Target value</span>
            <input
              id="goal-value"
              aria-label="Target value"
              type="number"
              min={0}
              placeholder="0"
              value={value}
              onChange={(e) =>
                setValue(e.target.value === '' ? '' : Number(e.target.value))
              }
              className="h-9 rounded-lg border border-line bg-surface px-3 text-sm text-fg outline-none focus:border-line-focus"
            />
          </label>

          <label htmlFor="goal-dir" className="flex flex-col gap-1.5">
            <span className="text-sm font-medium text-fg">Direction</span>
            <select
              id="goal-dir"
              value={dir}
              onChange={(e) => setDir(e.target.value as 'above' | 'below')}
              className="h-9 rounded-lg border border-line bg-surface px-3 text-sm text-fg"
            >
              <option value="above">At or above target (≥)</option>
              <option value="below">At or below target (≤)</option>
            </select>
          </label>

          <div className="flex items-center gap-3 pt-2">
            <button
              type="button"
              disabled={!canSave}
              onClick={handleSave}
              className="rounded-xl bg-brand-active px-5 py-2 text-sm font-semibold text-white disabled:opacity-40 hover:opacity-90 transition-opacity"
            >
              Save goal
            </button>
            <Link
              to="/reporting/new"
              className="text-sm text-fg-secondary hover:text-fg"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
